import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for ShopsDistribution Action/Mutation Types. Use it in   shops/actions.js, shops/mutations.js and the Vuex Host Component

export const Shop_groupsData = createActionTypeModel("Shop_groupsData");
export const Shop_groupList = createActionTypeModel("Shop_groupList");
export const Shop_groupDetails = createActionTypeModel("Shop_groupDetails");
export const ShopRelation = createActionTypeModel("ShopRelation");
export const ShopGroupShop = createActionTypeModel("ShopGroupShop");
